// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 968) return "icecast-metadata-player-1.17.2.common.min.js";
	// return url for filenames based on template
	return "icecast-metadata-player-1.17.2." + {"122":"vorbis","388":"mpeg","390":"opus","496":"synaudio","756":"mediasource","983":"flac"}[chunkId] + ".min.js";
};